export const data = [
  {
    stt: 1,
    mnp: 123,
    company: "abc",
    catalog: "abc",
  },
];
